import { CountryModel } from ".";

export class RegionModel {
    Id: number;
    Name: string;
    CountryId: number;
    Country: CountryModel;

    constructor() {

    }
}